<template>
    <div>
        <b-button variant="gray" class="f-110 go-top py-0" v-if="isVisible" :aria-label="$t('맨 위로')" @click="backToTop">
            <fa icon="angle-up"></fa>
        </b-button>
    </div>
</template>
<script>
export default {
  data() {
    return {
        position: {x:0, y:0}
    }
  },
  computed: {
    isVisible: {
        get(){
            if(this.position.y <= 0.3) return false
            else return true
        }
    }
  },
  methods: {
    backToTop() {
      window.scrollTo({
          top: 0,
          behavior: 'smooth'
      })
    }
  },
  created(){
        if (!this.$isServer) {
        this._scrollListener = () => {
          // window.pageX/YOffset is equivalent to window.scrollX/Y, but works in IE
          // We round values because high-DPI devies can provide some really nasty subpixel values
          this.position = {
            x: Math.round(window.pageXOffset),
            y: Math.round(window.pageYOffset)
          }
        }

        // Call listener once to detect initial position
        this._scrollListener()

        // When scrolling, update the position
        window.addEventListener('scroll', this._scrollListener)
      }
  },
  mounted() {
  },
  beforeDestroy() {
    // Detach the listener when the component is gone
    window.removeEventListener('scroll', this._scrollListener)
  }
}
</script>
<style scoped>
.go-top {
    position: fixed;
    width: 34px;
    height: 34px;
    right: 2px;
    bottom: 5rem;
    z-index: 999;
}



</style>